import React from "react";

/**
 * Editorial layout for narrative pages (Coaching, Outplacement…).
 * — No numbering, no bullet dots.
 * — Section title in serif small-caps brand color, hairline rule.
 * — Each item is a stand-alone paragraph, separated by an ivory hairline.
 * — Two-column layout: title left, narrative right.
 */
export default function SectionedNarrative({ sections, testId = "narrative" }) {
  return (
    <section className="px-6 md:px-10 max-w-[1280px] mx-auto py-12 md:py-16">
      <div className="space-y-12 md:space-y-14">
        {sections.map((s, i) => (
          <article key={s.t} data-testid={`${testId}-section-${i}`} className="grid grid-cols-12 gap-5 md:gap-10">
            <header className="col-span-12 md:col-span-4 md:sticky md:top-32 md:self-start">
              <div className="h-px w-12 bg-brand mb-4"></div>
              <h2 className="font-serif text-2xl md:text-3xl font-light text-brand uppercase tracking-[0.08em] leading-snug">
                {s.t}
              </h2>
            </header>
            <div className="col-span-12 md:col-span-7 md:col-start-6">
              <div className="space-y-3 md:space-y-4">
                {s.items.map((item, idx) => (
                  <p
                    key={idx}
                    className="text-ink/85 text-base md:text-[17px] leading-[1.55] font-light first-letter:font-serif first-letter:text-navy"
                  >
                    {item}
                  </p>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
